import { ALL_SPREAD_DEFINITIONS } from './all-spreads.js';
import { SPREADS_BY_INTENT } from './by-intent.js';
export const SPREADS_BY_CATEGORY = {
    core: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.spread.category === 'core'),
    special: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.spread.category === 'special'),
    lilith: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.spread.category === 'lilith'),
    kabbalistic: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.spread.category === 'kabbalistic'),
    custom: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.spread.category === 'custom'),
};
export const SPREADS_BY_FAMILY = {
    single: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.family === 'single'),
    triad: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.family === 'triad'),
    line: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.family === 'line'),
    cross: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.family === 'cross'),
    horseshoe: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.family === 'horseshoe'),
    wheel: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.family === 'wheel'),
    mirror: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.family === 'mirror'),
    tree: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.family === 'tree'),
    grid: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.family === 'grid'),
    custom: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.family === 'custom'),
};
export { SPREADS_BY_INTENT };
//# sourceMappingURL=by-category.js.map